import React from "react";
import { Row, Col, Form, Input, Button, message } from 'antd';
import axios from "axios";
import { withTranslation } from 'react-i18next';

class PasswordSettingsForm extends React.Component {
    state = {
        loading: true
    };

    componentDidMount() {
        let token = localStorage.getItem('token');
        axios.defaults.xsrfCookieName = 'csrftoken'
        axios.defaults.xsrfHeaderName = "X_CSRFTOKEN"
        axios.defaults.headers = {
            "Content-Type": "application/json",
            "Accept-Language": localStorage.getItem('language'),
            Authorization: `Token ${token}`,
        };
    }

    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.handleFormSubmit(
                    values,
                    e,
                    this.props.requestType,
                )
                console.log('Received values of form: ', values);
            }
        });
    };

    handleFormSubmit = (values) => {
        const postObj = {
            old_password: values.old_password,
            new_password1: values.new_password1,
            new_password2: values.new_password2
        }

        axios.post(process.env.REACT_APP_AXIOS_URL + "/rest-auth/password/change/", postObj)
            .then(res => {
                if (res.status === 200) {
                    message.success(this.props.t('profile.password_settings.changed', "Password changed"));
                } else {
                    message.error(this.props.t('profile.password_settings.failed_to_change', "Failed to change password"));
                }
            }).catch(error => {
                if (error.response.data.old_password)
                    message.error(this.props.t('profile.password_settings.invalid_password', "Invalid current password"));
                if (error.response.data.new_password1 || error.response.data.new_password2)
                    message.error(this.props.t('profile.password_settings.invalid_new_passwords', "The two new passwords fields didn't match"));
            });
    };


    render() {
        const { getFieldDecorator } = this.props.form;
        const { t } = this.props;

        return (
            <Form layout="vertical" hideRequiredMark onSubmit={this.handleSubmit}>
                <Row>
                    <Col span={8}>
                        <Form.Item label={t('profile.password_settings.old_password', "Old password")} >
                            {
                                getFieldDecorator('old_password', {
                                    rules: [{ required: true, message: t('profile.password_settings.old_password_required', 'Please input the old password') }],
                                })(<Input name="old_password" type="password" />)
                            }
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col span={8}>
                        <Form.Item label={t('profile.password_settings.new_password1', "New password")}>
                            {
                                getFieldDecorator('new_password1', {
                                    rules: [{ required: true, message: t('profile.password_settings.new_password1_required', "Please input a new password") }],
                                })(<Input name="new_password1" type="password" />)
                            }
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col span={8}>
                        <Form.Item label={t('profile.password_settings.new_password2', "Confirm new password")}>
                            {
                                getFieldDecorator('new_password2', {
                                    rules: [{ required: true, message: t('profile.password_settings.new_password2_required', "Please input a new password again") }],
                                })(<Input name="new_password2" type="password" />)
                            }
                        </Form.Item>
                    </Col>
                </Row>
                <Form.Item>
                    <Button type="primary" htmlType="submit">
                        {t('general.update', "Update")}
                    </Button>
                </Form.Item>
            </Form>


        );
    }

}

const PasswordSettings = Form.create()(withTranslation()(PasswordSettingsForm));

export default PasswordSettings;


// WEBPACK FOOTER //
// ./src/containers/Profile/PasswordSettings.js